import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapMutations } from 'vuex';
import _ from 'lodash';

export default {
  props: {},
  components: {},
  data: function data() {
    return {
      defaultProps: {
        children: 'sub_category',
        label: 'name'
      },
      downtown: {
        list: [],
        title: '',
        isChecked: false,
        totalNum: 0,
        checkedNum: 0,
        checkall: false
      },
      uptown: {
        list: [],
        title: '',
        isChecked: false,
        totalNum: 0,
        currentItem: '',
        checkedNum: 0
      },
      currentUptownItem: ''
    };
  },

  computed: _extends({}, mapState({
    menuTransferDialog: function menuTransferDialog(state) {
      return state.creative.template.menuTransferDialog;
    },
    categoryRef: function categoryRef(state) {
      return state.creative.template.templateConfig.category_ref;
    },
    category: function category(state) {
      return state.creative.template.templateConfig.category || [];
    }
  }), {
    canUptown: function canUptown() {
      return this.uptown.currentItem && this.downtown.isChecked;
    },
    canDowntown: function canDowntown() {
      return this.uptown.isChecked;
    }
  }),
  mounted: function mounted() {
    if (this.category) {
      this.initTreeView();
    }
  },

  methods: _extends({}, mapMutations({
    openMenuTransferDialog: 'creative/template/openMenuTransferDialog',
    closeMenuTransferDialog: 'creative/template/closeMenuTransferDialog',
    updateOutlineCategory: 'creative/template/updateOutlineCategory',
    updateTemplateCategory: 'creative/template/updateTemplateCategory'
  }), {
    handleNodeClick: function handleNodeClick(node) {
      if (node.sub_category || node.pid === 1) {
        this.uptown.currentItem = node;
      } else {
        this.uptown.currentItem = { id: node.pid };
      }
    },
    handleDownTownCheck: function handleDownTownCheck() {
      if (this.downtown.checkall) {
        this.$refs['downtown-tree'].setCheckedKeys(this.downtown.list.map(function (item) {
          return item.id;
        }));
      } else {
        this.$refs['downtown-tree'].setCheckedKeys([]);
      }
    },
    handleUpTownCheck: function handleUpTownCheck() {
      if (this.uptown.checkall) {
        var checklist = [];
        this.uptown.list.forEach(function (item) {
          if (item.sub_category) {
            checklist = checklist.concat(item.sub_category.map(function (ele) {
              if (ele.disabled) {
                return '';
              }
              return ele.id;
            }));
          }
        });
        this.$refs['uptown-tree'].setCheckedKeys(checklist);
      } else {
        this.$refs['uptown-tree'].setCheckedKeys([]);
      }
    },
    handleUptownChange: function handleUptownChange() {
      // 更新展示视图
      this.updateTreeView();
    },
    handleDowntownChange: function handleDowntownChange() {
      // 更新展示视图
      this.updateTreeView();
    },
    handleToUptown: function handleToUptown() {
      var _this = this;

      var checkList = this.$refs['downtown-tree'].getCheckedNodes().map(function (item) {
        item.pid = _this.uptown.currentItem.id;
        return item;
      });
      var tempList = _.clone(this.uptown.list);
      var addTreeItem = function addTreeItem(tree, list) {
        tree.forEach(function (item) {
          if (item.id === _this.uptown.currentItem.id) {
            if (item.sub_category) {
              item.sub_category = item.sub_category.concat(list);
            } else {
              item.sub_category = list;
            }
          }
          if (item.sub_category) {
            item.sub_category = addTreeItem(item.sub_category, list);
          }
        });
        return tree;
      };
      tempList = addTreeItem(tempList, checkList);
      this.uptown.list = tempList;
      this.downtown.list = _.differenceWith(this.downtown.list, checkList, _.isEqual);
      this.updateTreeView();
    },
    handleToDowntown: function handleToDowntown() {
      var checkList = this.$refs['uptown-tree'].getCheckedNodes(true).map(function (item) {
        item.pid = 4;
        return item;
      });
      this.downtown.list = this.downtown.list.concat(checkList);
      var tempList = _.clone(this.uptown.list);
      var removeTreeItem = function removeTreeItem(tree, list) {
        tree.forEach(function (item) {
          if (item.sub_category) {
            item.sub_category = _.differenceWith(item.sub_category, list, _.isEqual);
            item.sub_category = removeTreeItem(item.sub_category, list);
          }
        });
        return tree;
      };
      tempList = removeTreeItem(tempList, checkList);
      this.uptown.list = tempList;
      this.updateTreeView();
    },
    allowDrop: function allowDrop(draggingNode, dropNode, type) {
      var topAllow = dropNode.data.pid === 1 && type === 'inner';
      var leafAllow = dropNode.data.pid !== 1 && type !== 'inner' && dropNode.data.id !== draggingNode.data.id;
      return topAllow || leafAllow;
    },
    allowDrag: function allowDrag(draggingNode) {
      return draggingNode.data.pid !== 1;
    },
    closeDialog: function closeDialog() {
      this.closeMenuTransferDialog();
    },
    handleSubmit: function handleSubmit() {
      this.updateTemplateCategory(this.cookCategory());
      this.updateOutlineCategory();
      this.closeDialog();
      this.saveTemplateInfo();
      console.log('更新引导菜单');
    },
    saveTemplateInfo: function saveTemplateInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var loading;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                loading = _this2.$loading({
                  lock: true,
                  text: _this2.$t('playTurbo.custom.savingWarning'),
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });


                _this2.saving = true;

                _context.prev = 2;
                _context.next = 5;
                return _this2.$store.dispatch('creative/template/saveTemplate');

              case 5:
                _this2.saving = false;
                loading.close();
                _this2.$message({
                  type: 'success',
                  duration: 3000,
                  message: _this2.$t('playTurbo.custom.saveSuccess')
                });
                _this2.$router.go(0);
                _context.next = 17;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](2);

                console.error(_context.t0);
                _this2.saving = false;
                loading.close();
                _this2.$message.error(_context.t0.message || _this2.$t('playTurbo.common.save.fail'));

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 11]]);
      }))();
    },
    cookCategory: function cookCategory() {
      var _this3 = this;

      this.category.forEach(function (item) {
        if (item.id === 1) {
          var languageConfig = item.sub_category.find(function (el) {
            return el.id > 7;
          });
          var temp = _.cloneDeep(_this3.uptown.list);
          if (languageConfig) {
            temp.push(languageConfig);
          }
          temp.map(function (item) {
            if (item.sub_category) {
              item.sub_category = item.sub_category.map(function (ele) {
                ele.pid = item.id;
                delete ele.disabled;
                return ele;
              });
            }
            return item;
          });
          item.sub_category = temp;
        }
        if (item.id === 4) {
          item.sub_category = _this3.downtown.list;
        }
      });
      return this.category;
    },
    transPosition: function transPosition(type, data, node) {
      var parent = _.clone(node.parent);
      var children = parent.data.sub_category;
      var index = children.findIndex(function (d) {
        return d.id === data.id;
      });
      if (type === 'up') {
        if (index < 1) {
          this.$message({
            type: 'warning',
            message: '无法往上调整排序'
          });
          return;
        }
        var item = children.splice(index, 1);
        index = index - 1;
        children.splice(index, 0, item[0]);
      } else {
        if (index === children.length - 1) {
          this.$message({
            type: 'warning',
            message: '无法往下调整排序'
          });
          return;
        }
        var _item = children.splice(index, 1);
        index = index + 1;
        children.splice(index, 0, _item[0]);
      }
      var temp = _.clone(this.uptown.list);
      temp.forEach(function (item) {
        if (item.id === parent.data.id) {
          item.sub_category = children;
        }
      });
      this.uptown.list = temp;
    },
    renderContent: function renderContent(h, _ref) {
      var _this4 = this;

      var node = _ref.node,
          data = _ref.data,
          store = _ref.store;

      return h(
        'span',
        { 'class': 'custom-tree-node' },
        [h(
          'span',
          null,
          [node.label]
        ), node.data.pid !== 1 ? h(
          'span',
          { 'class': 'sort-bar' },
          [h(
            'el-button',
            {
              attrs: { icon: 'el-icon-arrow-up', size: 'mini', type: 'text' },
              on: {
                'click': function click() {
                  return _this4.transPosition('up', data, node);
                }
              }
            },
            []
          ), h(
            'el-button',
            {
              attrs: { icon: 'el-icon-arrow-down', size: 'mini', type: 'text' },
              on: {
                'click': function click() {
                  return _this4.transPosition('down', data, node);
                }
              }
            },
            []
          )]
        ) : h(
          'span',
          { 'class': 'total' },
          [node.data.sub_category ? node.data.sub_category.length : 0, ' \u6761']
        )]
      );
    },
    updateTreeView: function updateTreeView() {
      var _this5 = this;

      var uptowntotal = 0;
      this.uptown.list.forEach(function (item) {
        if (item.sub_category) {
          uptowntotal = item.sub_category.length + uptowntotal;
        }
      });
      this.uptown.totalNum = uptowntotal;
      this.downtown.totalNum = this.downtown.list.length;

      this.$nextTick(function () {
        if (_this5.$refs['downtown-tree']) _this5.downtown.checkedNum = _this5.$refs['downtown-tree'].getCheckedNodes().length;
        _this5.downtown.isChecked = _this5.downtown.checkedNum > 0;
        if (_this5.$refs['uptown-tree']) _this5.uptown.isChecked = _this5.$refs['uptown-tree'].getCheckedNodes().length > 0;
        if (_this5.$refs['uptown-tree']) _this5.uptown.checkedNum = _this5.$refs['uptown-tree'].getCheckedNodes().length;
      });
    },
    initTreeView: function initTreeView() {
      var temp = _.cloneDeep(this.category);
      var elementCategory = temp.find(function (item) {
        return item.id === 1;
      });
      var expandCategory = temp.find(function (item) {
        return item.id === 4;
      });
      if (elementCategory) {
        // 标题设置
        this.uptown.title = elementCategory.name;
        this.downtown.title = expandCategory ? expandCategory.name : '';
        // 列表设置
        var filterElementCategory = function filterElementCategory(category) {
          if (category.sub_category) {
            return category.sub_category.filter(function (item) {
              return item.id <= 7;
            });
          }
          return [];
        };

        this.downtown.list = expandCategory && expandCategory.sub_category ? expandCategory.sub_category : [];
        this.uptown.list = filterElementCategory(elementCategory);
        this.updateTreeView();
      }
    }
  }),
  watch: {
    'menuTransferDialog.visible': function menuTransferDialogVisible(val) {
      // 更新展示视图
      this.initTreeView();
    },
    'downtown.checkall': function downtownCheckall(val) {
      this.handleDownTownCheck();
    },
    'uptown.checkall': function uptownCheckall(val) {
      this.handleUpTownCheck();
    }
  }
};